import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=fec178a6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fec178a6')) {
      api.createRecord('fec178a6', component.options)
    } else {
      api.reload('fec178a6', component.options)
    }
    module.hot.accept("./Integrations.vue?vue&type=template&id=fec178a6&", function () {
      api.rerender('fec178a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Integrations.vue"
export default component.exports